import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useIsCreditFeatureDisabled } from '../../../../hooks/useIsCreditFeatureDisabled';
import { KNOWLEDGE_URLS } from '../../../../shared/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreditStatusTooltip = ({
  children,
  action,
  featureName,
  disabled,
  placement,
  featureType
}) => {
  const {
    loading,
    error,
    isDisabled: isCreditFeatureDisabled,
    resetDate
  } = useIsCreditFeatureDisabled(action || featureType);
  const isDisabled = disabled || !loading && !error && isCreditFeatureDisabled;
  const getTooltipContent = () => {
    if (isDisabled) {
      const titleElement = featureName ? /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "creditsAwareness.creditStatusTooltip.disabled.title",
        options: {
          featureName // Consumer is responsible for translating the feature name
        }
      }) :
      /*#__PURE__*/
      //This won't be used yet since featureName is still required
      _jsx(FormattedJSXMessage, {
        message: "creditsAwareness.creditStatusTooltip.disabled.actionTitle_jsx",
        elements: {
          FormattedMessage
        },
        options: {
          action
        }
      });
      return /*#__PURE__*/_jsxs(Text, {
        use: "on-dark",
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "strong",
          use: "on-dark",
          children: [titleElement, ' ']
        }), resetDate && /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "creditsAwareness.creditStatusTooltip.disabled.description_jsx",
          elements: {
            FormattedDateTime
          },
          options: {
            resetDate
          }
        })]
      });
    }
    return /*#__PURE__*/_jsxs(Text, {
      use: "on-dark",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "creditsAwareness.creditStatusTooltip.enabled.title"
      }), ' ', /*#__PURE__*/_jsx(Link, {
        href: KNOWLEDGE_URLS.HUBSPOT_CREDITS,
        use: "on-dark",
        external: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "creditsAwareness.creditStatusTooltip.enabled.learnMore"
        })
      })]
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "credit-status-tooltip",
    title: getTooltipContent(),
    placement: placement,
    children: children
  });
};